import { createFileRoute } from '@tanstack/react-router';

import { ConsentsPage } from '@/features/subcontracts/consents-page';

export const Route = createFileRoute('/_app/projects/$projectId/subcontracts/consents')({
  component: PageRoute,
});

function PageRoute() {
  const { projectId } = Route.useParams();
  return <ConsentsPage projectId={projectId} />;
}
